<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-2 p-0 m-0">
            <bita-bootbutton
              v-if="!showForm"
              type="primary"
              title="افزودن  نوع ماشین"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="toggleFormCreate"
            />
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :categories="categories"
      modal-id="edit-modal"
      title="ویرایش نوع ماشین"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      :categories="categories"
      modal-id="create-modal"
      title="اضافه کردن نوع ماشین"
      @on-submit="handleCreate"
    />
  </div>
</template>
<script>
import VehicleTypesForm from "./Form";

export default {
  components: { "form-modal": VehicleTypesForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت سیستم", link: "" },
        {
          title: "مدیریت نوع ماشین",
          link: "/vehicle-types",
          active: true,
        },
      ],
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      createForm: {
        name: "",
        parent_id: "",
      },
      categories: [
        {
          id: 0,
          name: "هیچکدام",
        },
      ],
      updateForm: {},
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام", width: "100px" },
        { field: "vehicle_type_code", title: "کد", width: "100px" },
        {
          field: "parent_item",
          title: "دسته بندی",
          template: (e) => (e.parent_item ? e.parent_item.name : " - "),
          width: "100px",
        },
        {
          title: "عملیات",
          command: [],
          width: "150px",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.loadData();
    this.getCategory();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    handleCreate(data) {
      this.isLoadingModal = true;

      this.$persistClient("post", "vehicle-types", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.createForm = {
            name: "",
            parent_id: "",
          };

          this.loadData();
          this.$refs.createModal.reset();

          this.statusChangeModalCreate();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleEdit(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `vehicle-types/${data.id}`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {
            name: "",
           vehicle_type_code:"",
            parent_id: "",
          };

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;
      this.$persistClient("get", "vehicle-types?include=parentItem")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    delete(e) {
      let vehicleTypes = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف ${vehicleTypes.name} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `vehicle-types/${vehicleTypes.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    getCategory() {
      this.$persistClient("get", `vehicle-types?filter[parent]=0`)
        .then((res) => {
          this.categories = [
            {
              id: 0,
              name: "هیچکدام",
            },
          ];

          for (var i = 0; i < res.data.length; i++) {
            this.categories.push(res.data[i]);
          }
        })
        .finally(() => {});
    },
    toggleFormCreate() {
      this.statusChangeModalCreate();
    },
    toggleFormEdit() {
      this.statusChangeModalEdit();
    },
    loadData() {
      this.$refs.grid.loadDataSource();
      this.getCategory();
    },
    statusChangeModalEdit() {
      this.$toggleModal("#edit-modal");
    },
    statusChangeModalCreate() {
      this.$toggleModal("#create-modal");
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    edit(e) {
      let vehicleTypes = this.$refs.grid.getSelectedGridRow(e);

      this.updateForm = {
        id: vehicleTypes.id,
        name: vehicleTypes.name,
        vehicle_type_code:vehicleTypes.vehicle_type_code,
        parent_id: vehicleTypes.parent_item ? vehicleTypes.parent_item.id : 0,
      };

      this.toggleFormEdit();
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
